import type { Category } from '@freelancer/datastore/collections';
import type { IconName } from '@freelancer/ui/icon';

export enum SkillsButtonType {
  NEXT = 'next',
  SAVE = 'save',
}

const DEFAULT_ICON = 'flBlocks';

const JOB_CATEGORY_ICON_MAP: Map<number, IconName> = new Map([
  [1, 'flComputerOutline'], // Websites, IT & Software
  [2, 'flPentool'], // Writing & Content
  [3, 'flPenbrush'], // Design, Media & Architecture
  [4, 'flKeyboard'], // Data Entry & Admin
  [5, 'flBeaker'], // Engineering & Science
  [6, 'flGraphIncrease'], // Sales & Marketing
  [7, 'flBankV2'], // Business, Accounting, Human Resources & Legal
  [8, 'flFactory'], // Product Sourcing & Manufacturing
  [9, 'flDevicesV2'], // Mobile Phones & Computing
  [10, 'flChatSquareV2'], // Translation & Languages
  [12, 'flTradesAndServices'], // Trades & Services
  [99, 'flJobsForAnyone'], // Jobs for Anyone
  [100, 'flTruck'], // Freight, Shipping & Transportation
  [101, 'flTelecom'], // Telecom
  [102, 'flEducation'], // Education
  [103, 'flHealthAndMedicine'], // Health & Medicine
  [104, 'flArtificialIntelligence'], // Artificial Intelligence
]);

/**
 * Gets the correct icon for each category from the category mappings.
 * @param category Category to get icon for.
 */
export function getSkillCategoryIcon(category: Category): IconName {
  return JOB_CATEGORY_ICON_MAP.get(category.id) || DEFAULT_ICON;
}
